// extracted by mini-css-extract-plugin
module.exports = {"errorPageHolder":"TimeoutErrorPage_errorPageHolder__3IA6l","showboatLogo":"TimeoutErrorPage_showboatLogo__1hBrD","showboatLogoMobile":"TimeoutErrorPage_showboatLogoMobile__TER0i"};